export default "__VITE_ASSET__fdc9519d__"